/* eslint-disable camelcase */
import Game from './scenes/Game';
import Intro from './scenes/Intro';
import Slides from './scenes/Slides';
import Title from './scenes/Title';

export default {
  /**
     * Add your scene classes here. Simply put the scene class.
     * Ex: `scenes: [MyScene,MyOtherScene]`
     * @type {{KEY:string}[]}
     */
  scenes: [Title, Intro, Slides, Game],

  /**
     * Set the first scene that should be loaded here. Must match one of the scenes' key found in the scenes array.
     * It is recommended you put `MyScene.KEY` here instead of using a string.
     * @type {string}
     */
  startScene: Title.KEY,

  SENSES_CHARACTERS: [ // Line these up w/ the json data automatically not lazy
    { num: 1,name: 'Smell', x: 245, y: 500, shadowoffset: -130, armoffset: { x: 0,y: 0 } },
    { num: 2, name: 'Sight', x: 387, y: 460, shadowoffset: -180, armoffset: { x: -40,y: -109 } },
    { num: 3, name: 'Taste', x: 528, y: 444, shadowoffset: -160, armoffset: { x: 11,y: 60 } },
    { num: 4, name: 'Hear', x: 667, y: 460, shadowoffset: -170, armoffset: { x: 15,y: 45 } },
    { num: 5, name: 'Touch', x: 810, y: 458, shadowoffset: -100, armoffset: { x: 60,y: -42 } }
  ],

  introText: '',
  slideData: [
    { slideid: 1,
      slidetext: 'slide_data.slidetext_1',
      slideaudio: 'I_use_my_nose_to_smell',
      slidesense: 'Smell' },

    { slideid: 2,
      slidetext: 'slide_data.slidetext_2',
      slideaudio: 'I_use_my_eyes_to_see',
      slidesense: 'Sight' },

    { slideid: 3,
      slidetext: 'slide_data.slidetext_3',
      slideaudio: 'I_use_my_tongue_to_taste',
      slidesense: 'Taste' },

    { slideid: 4,
      slidetext: 'slide_data.slidetext_4',
      slideaudio: 'I_use_my_ears_to_hear',
      slidesense: 'Hear' },

    { slideid: 5,
      slidetext: 'slide_data.slidetext_5',
      slideaudio: 'I_use_my_hands_to_touch',
      slidesense: 'Touch' }
  ],

  questionData: {
    introAudio: 'Lets_play_a_game',
    finishedAudio: 'You_know_five_senses',
    correctFeedback: [
      { text: 'question_data.correct_1', audiofile: 'nice_one' },
      { text: 'question_data.correct_2',audiofile: 'awesome' }
    ],
    incorrectFeedback: [
      { text: 'question_data.incorrect_1', audiofile: 'not_quite' },
      { text: 'question_data.incorrect_2',audiofile: 'I_dont_think_so' }
    ],
    questions: [
      { questionID: 1, text: 'question_data.question_1', audiofile: 'Bunny', correctSense: 'Touch' },
      { questionID: 2, text: 'question_data.question_2', audiofile: 'Pool', correctSense: 'Touch' },
      { questionID: 3, text: 'question_data.question_3', audiofile: 'Pizza', correctSense: 'Taste' },
      { questionID: 4, text: 'question_data.question_4', audiofile: 'Candy', correctSense: 'Taste' },
      { questionID: 5, text: 'question_data.question_5', audiofile: 'Crayon', correctSense: 'Sight' },
      { questionID: 6, text: 'question_data.question_6', audiofile: 'Car', correctSense: 'Sight' },
      { questionID: 7, text: 'question_data.question_7', audiofile: 'Sky', correctSense: 'Sight' },
      { questionID: 8, text: 'question_data.question_8', audiofile: 'Teacher', correctSense: 'Hear' },
      { questionID: 9, text: 'question_data.question_9', audiofile: 'School_bell', correctSense: 'Hear' },
      { questionID: 10, text: 'question_data.question_10', audiofile: 'Music', correctSense: 'Hear' },
      { questionID: 11, text: 'question_data.question_11', audiofile: 'Garbage', correctSense: 'Smell' },
      { questionID: 12, text: 'question_data.question_12', audiofile: 'Perfume', correctSense: 'Smell' }
    ]
  }
};
